/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FileSignedUrl } from '../../models/file-signed-url';

export interface GetSubmissionFilesUploadedUrlsApiV2SubmissionsOrgIdFilesUrlGet$Params {
  id: string;
  org: string;

/**
 * Optional list of file names to filter for retrieval of signed URLs
 */
  filenames?: (Array<string> | null);
}

export function getSubmissionFilesUploadedUrlsApiV2SubmissionsOrgIdFilesUrlGet(http: HttpClient, rootUrl: string, params: GetSubmissionFilesUploadedUrlsApiV2SubmissionsOrgIdFilesUrlGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FileSignedUrl>>> {
  const rb = new RequestBuilder(rootUrl, getSubmissionFilesUploadedUrlsApiV2SubmissionsOrgIdFilesUrlGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('org', params.org, {});
    rb.query('filenames', params.filenames, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FileSignedUrl>>;
    })
  );
}

getSubmissionFilesUploadedUrlsApiV2SubmissionsOrgIdFilesUrlGet.PATH = '/api/v2/submissions/{org}/{id}/files/url';
